// const BASE_URL = "http://0.0.0.0:3001/api";
export const BASE_MOBILE_URL = "https://api.hairandhands.com/mobile/api";
const BASE_URL = "https://api.hairandhands.com/api";
// export const BASE_MOBILE_URL = "http://0.0.0.0:3001/mobile/api";
// const BASE_URL = "http://0.0.0.0:3001/api";
// const BASE_MOBILE_URL = "https://peluquerias-pe.appspot.com/mobile/api";

export const LOGIN_URL = `${BASE_URL}/login`;
export const FORGOT_PASSWORD_URL = `${BASE_URL}/forgotpassword`;
export const ME_URL = `${BASE_URL}/me`;
export const USER_URL = `${BASE_URL}/users`;
export const STORE_URL = `${BASE_URL}/stores`;
export const ROLE_URL = `${BASE_URL}/roles`;
export const PRODUCT_URL = `${BASE_URL}/products`;
export const CATEGORY_URL = `${BASE_URL}/categories`;
export const SERVICE_URL = `${BASE_URL}/services`;
export const PROVIDER_URL = `${BASE_URL}/providers`;
export const CUSTOMER_URL = `${BASE_URL}/customers`;
export const EMPLOYEE_URL = `${BASE_URL}/employees`;
export const SELL_URL = `${BASE_URL}/sells`;
export const REPORT_URL = `${BASE_URL}/reports`;
export const DASHBOARD_URL = `${BASE_URL}/dashboard`;
export const NOTIFICATION_URL = `${BASE_URL}/notifications`;
export const MOVE_TYPE_URL = `${BASE_URL}/move_types`;
export const OFFER_URL = `${BASE_URL}/offers`;
export const QUOTATION_URL = `${BASE_URL}/quotations`;
export const DOCUMENT_TYPE_URL = `${BASE_URL}/document-types`;
export const CONTACT_US_URL = `${BASE_URL}/contact-us`;
export const FRANCHISE_URL = `${BASE_URL}/franchises`;
export const REWARDS_WEB_URL = `${BASE_URL}/rewards-web`;

export const MOBILE_REWARD_URL = `${BASE_MOBILE_URL}/rewards`;
export const MOBILE_COUPON_URL = `${BASE_MOBILE_URL}/coupons`;
export const MOBILE_SERVICE_URL = `${BASE_MOBILE_URL}/services`;
export const MOBILE_CUSTOMER_URL = `${BASE_MOBILE_URL}/customers`;
export const MOBILE_EMPLOYEE_URL = `${BASE_MOBILE_URL}/employees`;
export const MOBILE_NEWSLETTER_URL = `${BASE_MOBILE_URL}/newsletters`;



// WEBPACK FOOTER //
// ./src/service/api/index.js